// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { QuickTableUtils } from '../QuickTableUtils';
import { SolidBrush } from '@shared/commons/Graphics';
import { ThemeManager } from '../../../misc/ThemeManager';
export class OrderTypeColumnRenderer {
    DrawCell(context, eventArgs) {
        var _a;
        const isOvernightTradingHours = (_a = eventArgs.row.item) === null || _a === void 0 ? void 0 : _a.isOvernightTradingHours;
        if (isNullOrUndefined(isOvernightTradingHours) || !isOvernightTradingHours()) {
            return;
        }
        const cellRect = new Rectangle(eventArgs.x, eventArgs.y, eventArgs.width, eventArgs.height);
        const xPadding = eventArgs.table.getXPadding(eventArgs.columnIndex, context.textAlign);
        const yPadding = eventArgs.table.getYPadding(cellRect.Height, QuickTableUtils.GetTextHeight(context));
        const rectBrush = new SolidBrush(eventArgs.BackColor);
        context.FillRectWithRect(rectBrush, cellRect);
        const icon = ThemeManager.NewImages.tableOrderOvernightIcon;
        const iconRect = eventArgs.table.getButtonRectangle(cellRect.X, cellRect.Y, cellRect.Width, cellRect.Height);
        iconRect.X = cellRect.Right() - iconRect.Width;
        cellRect.Width -= iconRect.Width;
        context.DrawCenteredImage(icon.image, iconRect);
        const textBrush = new SolidBrush(eventArgs.ForeColor);
        QuickTableUtils.DrawTextInRect(context, eventArgs.cell.formattedValue, eventArgs.font, textBrush, cellRect.X, cellRect.Y, cellRect.Width, cellRect.Height, xPadding, yPadding, true);
        eventArgs.handled = true;
    }
    ProcessMouseMove(eventArgs) {
        /* do nothing, we don't need to handle mouse move for this column */
    }
    ProcessMouseLeave(eventArgs) {
        /* do nothing, we don't need to handle mouse leave for this column */
    }
}
